export const timeoutFetch = function (url, options, timeout = 7000) {
    return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
            setTimeout(() => reject(new Error('timeout')), timeout)
        )
    ]);
}

export const timeoutPromise = (targetTime = 1000) => {
    return new Promise((resolve, reject) => {
        setTimeout(function () {
            resolve(); // ¡Todo salió bien!
        }, targetTime);
    })
}


export const registerAuditProcess = (props, auditRecordDetail) => {
    // if (props.enableAuditRegistering) {
    if (process.env.REACT_APP_ALLOW_AUDIT_RECORDS === "true") {
        fetch(process.env.REACT_APP_API_URL + "/auditRecords/", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": "Token " + props.activeUser.authToken },
            body: JSON.stringify({
                ...auditRecordDetail,
                user: props.activeUser.id
            })
        })
            .then((serverResponse) => { })
            .catch((error) => { console.log(error); });
    }
    else { console.log("Debería guardar el record: " + auditRecordDetail.description); }
}